type ReactEnvName = 'local' | 'development' | 'staging' | 'production';
type NodeEnvName = 'development' | 'production' | 'test';
type EnvName = ReactEnvName | NodeEnvName;

interface Settings {
  projectRegion: string;
  identityPoolId: string;
  cognitoRegion: string;
  userPoolId: string;
  clientId: string;
  apiGateway: string;
  portalApi: string;
  portalDomain: string; // MFA対応
  redirectSignIn: string;
  redirectSignOut: string;
  cognitoDomain: string;
  aggridLicenceKey: string;
  useMockMfaAuth?: boolean; // MFA対応
}
interface EnvSettings {
  local: Settings;
  development: Settings;
  staging: Settings;
  test: Settings;
  production: Settings;
}

export const currentEnv: EnvName = process.env.REACT_APP_ENV; //|| process.env.NODE_ENV;

const envSettings: EnvSettings = {
  local: {
    projectRegion: 'ap-northeast-1',
    identityPoolId: '',
    cognitoRegion: 'ap-northeast-1',
    userPoolId: 'ap-northeast-1_lfKgSdiLf',
    clientId: '1u1m35uh0882f9grhl3qh6pikv',
    apiGateway: 'http://localhost:3010',
    portalApi: 'http://localhost:13010/user/v1.1/userInfo',
    portalDomain: 'http://localhost:13010', // MFA対応
    redirectSignIn: 'http://localhost:3000/',
    redirectSignOut: 'http://localhost:3000/',
    cognitoDomain: 'datainsight-pool-dev.auth.ap-northeast-1.amazoncognito.com',
    aggridLicenceKey:
      'Using_this_{AG_Grid}_Enterprise_key_{AG-050661}_in_excess_of_the_licence_granted_is_not_permitted___Please_report_misuse_to_legal@ag-grid.com___For_help_with_changing_this_key_please_contact_info@ag-grid.com___{Toyotsu_Syscom}_is_granted_a_{Multiple_Applications}_Developer_License_for_{15}_Front-End_JavaScript_developers___All_Front-End_JavaScript_developers_need_to_be_licensed_in_addition_to_the_ones_working_with_{AG_Grid}_Enterprise___This_key_has_been_granted_a_Deployment_License_Add-on_for_{2}_Production_Environments___This_key_works_with_{AG_Grid}_Enterprise_versions_released_before_{15_November_2024}____[v3]_[01]_MTczMTYyODgwMDAwMA==c8c0a18b3636f327eee47079f2b25bc0',
    useMockMfaAuth: true, // MFA対応 - trueの場合, MFA設定API(/auth/set-mfa)のresponseはモックデータから取得
  },
  development: {
    projectRegion: 'ap-northeast-1',
    identityPoolId: '',
    cognitoRegion: 'ap-northeast-1',
    userPoolId: 'ap-northeast-1_lfKgSdiLf',
    clientId: '1u1m35uh0882f9grhl3qh6pikv',
    apiGateway: 'https://flour-server.datainsight-dev.toyota-tsusho.com',
    portalApi: 'https://portal-devevelopment-server.datainsight-dev.toyota-tsusho.com/user/v1.1/userInfo',
    portalDomain: 'https://portal-devevelopment-server.datainsight-dev.toyota-tsusho.com', // MFA対応
    redirectSignIn: 'https://flour.datainsight-dev.toyota-tsusho.com/',
    redirectSignOut: 'https://flour.datainsight-dev.toyota-tsusho.com/',
    cognitoDomain: 'datainsight-pool-dev.auth.ap-northeast-1.amazoncognito.com',
    aggridLicenceKey:
      'Using_this_{AG_Grid}_Enterprise_key_{AG-050661}_in_excess_of_the_licence_granted_is_not_permitted___Please_report_misuse_to_legal@ag-grid.com___For_help_with_changing_this_key_please_contact_info@ag-grid.com___{Toyotsu_Syscom}_is_granted_a_{Multiple_Applications}_Developer_License_for_{15}_Front-End_JavaScript_developers___All_Front-End_JavaScript_developers_need_to_be_licensed_in_addition_to_the_ones_working_with_{AG_Grid}_Enterprise___This_key_has_been_granted_a_Deployment_License_Add-on_for_{2}_Production_Environments___This_key_works_with_{AG_Grid}_Enterprise_versions_released_before_{15_November_2024}____[v3]_[01]_MTczMTYyODgwMDAwMA==c8c0a18b3636f327eee47079f2b25bc0',
    useMockMfaAuth: false, // MFA対応 - trueの場合, MFA設定API(/auth/set-mfa)のresponseはモックデータから取得
  },
  staging: {
    projectRegion: 'ap-northeast-1',
    identityPoolId: '',
    cognitoRegion: 'ap-northeast-1',
    userPoolId: 'ap-northeast-1_APA8bvSar',
    clientId: '79ctjv1n9derg30b5qicpfv21m',
    apiGateway: 'https://flour-server.datainsight-qas.toyota-tsusho.com',
    portalApi: 'https://portal-stg-server.datainsight-qas.toyota-tsusho.com/user/v1.1/userInfo',
    portalDomain: 'https://portal-stg-server.datainsight-qas.toyota-tsusho.com', // MFA対応
    redirectSignIn: 'https://flour.datainsight-qas.toyota-tsusho.com/',
    redirectSignOut: 'https://flour.datainsight-qas.toyota-tsusho.com/',
    cognitoDomain: 'datainsight-pool-stg.auth.ap-northeast-1.amazoncognito.com',
    aggridLicenceKey:
      'Using_this_{AG_Grid}_Enterprise_key_{AG-050661}_in_excess_of_the_licence_granted_is_not_permitted___Please_report_misuse_to_legal@ag-grid.com___For_help_with_changing_this_key_please_contact_info@ag-grid.com___{Toyotsu_Syscom}_is_granted_a_{Multiple_Applications}_Developer_License_for_{15}_Front-End_JavaScript_developers___All_Front-End_JavaScript_developers_need_to_be_licensed_in_addition_to_the_ones_working_with_{AG_Grid}_Enterprise___This_key_has_been_granted_a_Deployment_License_Add-on_for_{2}_Production_Environments___This_key_works_with_{AG_Grid}_Enterprise_versions_released_before_{15_November_2024}____[v3]_[01]_MTczMTYyODgwMDAwMA==c8c0a18b3636f327eee47079f2b25bc0',
    useMockMfaAuth: false, // MFA対応 - trueの場合, MFA設定API(/auth/set-mfa)のresponseはモックデータから取得
  },
  test: {
    // same as staging for fallback
    projectRegion: 'ap-northeast-1',
    identityPoolId: '',
    cognitoRegion: 'ap-northeast-1',
    userPoolId: 'ap-northeast-1_APA8bvSar',
    clientId: '79ctjv1n9derg30b5qicpfv21m',
    apiGateway: 'https://flour-server.datainsight-qas.toyota-tsusho.com',
    portalApi: 'https://portal-stg-server.datainsight-qas.toyota-tsusho.com/user/v1.1/userInfo',
    portalDomain: 'https://portal-stg-server.datainsight-qas.toyota-tsusho.com', // MFA対応
    redirectSignIn: 'https://flour.datainsight-qas.toyota-tsusho.com/',
    redirectSignOut: 'https://flour.datainsight-qas.toyota-tsusho.com/',
    cognitoDomain: 'datainsight-pool-stg.auth.ap-northeast-1.amazoncognito.com',
    aggridLicenceKey:
      'Using_this_{AG_Grid}_Enterprise_key_{AG-050661}_in_excess_of_the_licence_granted_is_not_permitted___Please_report_misuse_to_legal@ag-grid.com___For_help_with_changing_this_key_please_contact_info@ag-grid.com___{Toyotsu_Syscom}_is_granted_a_{Multiple_Applications}_Developer_License_for_{15}_Front-End_JavaScript_developers___All_Front-End_JavaScript_developers_need_to_be_licensed_in_addition_to_the_ones_working_with_{AG_Grid}_Enterprise___This_key_has_been_granted_a_Deployment_License_Add-on_for_{2}_Production_Environments___This_key_works_with_{AG_Grid}_Enterprise_versions_released_before_{15_November_2024}____[v3]_[01]_MTczMTYyODgwMDAwMA==c8c0a18b3636f327eee47079f2b25bc0',
    useMockMfaAuth: false, // MFA対応 - trueの場合, MFA設定API(/auth/set-mfa)のresponseはモックデータから取得
  },
  production: {
    projectRegion: 'ap-northeast-1',
    identityPoolId: '',
    cognitoRegion: 'ap-northeast-1',
    userPoolId: 'ap-northeast-1_0zpIatPef',
    clientId: '2k6me5q4riveddsst8jep2gc01',
    apiGateway: 'https://flour-server.datainsight.toyota-tsusho.com',
    portalApi: 'https://portal-server.datainsight.toyota-tsusho.com/user/v1.1/userInfo',
    portalDomain: 'https://portal-server.datainsight.toyota-tsusho.com', // MFA対応
    redirectSignIn: 'https://flour.datainsight.toyota-tsusho.com',
    redirectSignOut: 'https://flour.datainsight.toyota-tsusho.com',
    cognitoDomain: 'datainsight-pool.auth.ap-northeast-1.amazoncognito.com',
    aggridLicenceKey:
      'Using_this_{AG_Grid}_Enterprise_key_{AG-050661}_in_excess_of_the_licence_granted_is_not_permitted___Please_report_misuse_to_legal@ag-grid.com___For_help_with_changing_this_key_please_contact_info@ag-grid.com___{Toyotsu_Syscom}_is_granted_a_{Multiple_Applications}_Developer_License_for_{15}_Front-End_JavaScript_developers___All_Front-End_JavaScript_developers_need_to_be_licensed_in_addition_to_the_ones_working_with_{AG_Grid}_Enterprise___This_key_has_been_granted_a_Deployment_License_Add-on_for_{2}_Production_Environments___This_key_works_with_{AG_Grid}_Enterprise_versions_released_before_{15_November_2024}____[v3]_[01]_MTczMTYyODgwMDAwMA==c8c0a18b3636f327eee47079f2b25bc0',
    useMockMfaAuth: false, // MFA対応 - trueの場合, MFA設定API(/auth/set-mfa)のresponseはモックデータから取得
  },
};
// console.log(envSettings[currentEnv]);

export const amplifyConfig = {
  aws_project_region: envSettings[currentEnv].projectRegion,
  aws_cognito_identity_pool_id: envSettings[currentEnv].identityPoolId,
  aws_cognito_region: envSettings[currentEnv].cognitoRegion,
  aws_user_pools_id: envSettings[currentEnv].userPoolId,
  aws_user_pools_web_client_id: envSettings[currentEnv].clientId,
  redirect_sign_in: envSettings[currentEnv].redirectSignIn,
  redirect_sign_out: envSettings[currentEnv].redirectSignOut,
  cognitoDomain: envSettings[currentEnv].cognitoDomain,
};

export const cognitoConfig = {
  userPoolId: envSettings[currentEnv].userPoolId,
  clientId: envSettings[currentEnv].clientId,
};

export const apiGateway = envSettings[currentEnv].apiGateway;
export const portalApi = envSettings[currentEnv].portalApi;
export const portalDomain = envSettings[currentEnv].portalDomain; // MFA対応
export const aggridLicenceKey = envSettings[currentEnv].aggridLicenceKey;
export const useMockMfaAuth = envSettings[currentEnv].useMockMfaAuth; // MFA対応

export const HEADER = {
  MOBILE_HEIGHT: 64,
  MAIN_DESKTOP_HEIGHT: 88,
  DASHBOARD_DESKTOP_HEIGHT: 50,
  DASHBOARD_DESKTOP_OFFSET_HEIGHT: 92 - 40,
};

export const NAVBAR = {
  BASE_WIDTH: 260,
  DASHBOARD_WIDTH: 280,
  DASHBOARD_COLLAPSE_WIDTH: 88,
  //
  DASHBOARD_ITEM_ROOT_HEIGHT: 48,
  DASHBOARD_ITEM_SUB_HEIGHT: 40,
  DASHBOARD_ITEM_HORIZONTAL_HEIGHT: 32,
};

export const ICON = {
  NAVBAR_ITEM: 22,
  NAVBAR_ITEM_HORIZONTAL: 20,
};
